import { ConnectPlaceholder } from './connect-placeholder';

export function ConnectApiKeysPage() {
  return <ConnectPlaceholder section="API Keys" />;
}
